<template>
    <div class="listmain ">
        <h1 class="firTitle">语音伴侣SDK（Android）</h1>
        <h3 class="sedTitle">Android端语音伴侣SDK说明文档</h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
        猎户星空Android端SDK将为您提供的功能包括: 交互数据的信息流、音箱提供的技能列表、可定制的技能详情、支付与小微登录的接入、自定义主题
          </span>
        </p>
        <h3 class="sedTitle">接入帮助</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
        引入sdk
          </span>
        </p>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
1.SDK的功能都整合到了orion-sdk-client-release.aar文件中，接入方需要将其拷贝并粘贴到libs文件夹下<br>
2.在build文件下dependencies中添加如下代码
          </span>
        </p>
        <highlight-code lang="javascript">
            compile(name:'orion-sdk-client-release', ext:'aar')
        </highlight-code>


        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
        3.因为控件里需要下载网络图片，SDK中用了glide,所以还需要引入与之相关的俩个库，还有三个android的support库。如果接入方应用已经引用，则无需再次引用，并以接入方引用版本为主
          </span>
        </p>

        <highlight-code lang="javascript">
            compile 'com.android.support:appcompat-v7:25.3.0'
            compile 'com.android.support:support-v4:25.3.0'
            compile 'com.android.support:recyclerview-v7:25.3.0'
            compile 'com.android.support.constraint:constraint-layout:1.0.2'
            compile 'com.android.support:cardview-v7:25.3.0'
            compile 'com.android.support:design:25.3.0'
            compile 'com.android.support:multidex:1.0.0'
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
              4.由于我们的SDK方法数超过了65535限制，需要宿主增加Multidex打包的代码设置。 3.因为控件里需要下载网络图片，SDK中用了glide,所以还需要引入与之相关的俩个库，还有三个android的support库。如果接入方应用已经引用，则无需再次引用，并以接入方引用版本为主
          </span>
        </p>

        <highlight-code lang="javascript">
            // 在`app`的`build.gradle`中
            android{
                ...
                defualtConfig{
                ...
                multiDexEnabled true
                }
                }
                // 在接入方App的`Application`中进行初始化
                protected void attachBaseContext(Context base) {
                    super.attachBaseContext(base);
                    MultiDex.install(this);
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
          5.在接入方Application的onCreate方法中增加配置信息，用来设置SDK的初始化设置。其中context为Applicaiton对象，name为音箱的名称缩写为String类型，config为SdkConfigBean对象，用于初始化SDK数据请求（具体内容与格式请咨询相关负责人获取。
          </span>
        </p>

        <highlight-code lang="javascript">
            OrionSdkClient.getInstance().init(context, name, config)
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
          6.若接入方有定制界面的需求，需要新建自定义主题并继承@style/orion_sdk_default_theme，重写其中需要进行定制自定义的项，详细的可定制项与定制方式请查看自定义主题清单。然后在Application中进行设置
          </span>
    </p>

        <highlight-code lang="javascript">
            OrionSdkClient.getInstance().setTheme(themeId)//themeId：自定义主题的id
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
          7.代码混淆 添加混淆代码，在宿主应用混淆文件中添加以下代码，防止混淆后，SDK解析数据出错
          </span>
        </p>

        <highlight-code lang="javascript">
            -renamesourcefileattribute SourceFile
            -keepattributes SourceFile,LineNumberTable
            -keep class com.sdk.orion.ui.bean.** {*;}
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
         8.由于SDK不提供字体大小的定制，为了保证不同手机上的显示效果一致，建议宿主在Application中锁定字体大小单位sp换算的比例大小
          </span>
        </p>

        <highlight-code lang="javascript">
            @Override
            public void onConfigurationChanged(Configuration newConfig) {
                if (newConfig.fontScale != 1)
                    getResources();
                super.onConfigurationChanged(newConfig);
            }
            @Override
            public Resources getResources() {
                Resources res = super.getResources();
                if (res.getConfiguration().fontScale != 1) {
                    Configuration newConfig = new Configuration();
                    newConfig.setToDefaults();
                    res.updateConfiguration(newConfig, res.getDisplayMetrics());
                }
                return res;
            }
        </highlight-code>

        <h3 class="sedTitle">sdk崩溃捕获</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
       我们做了SDK的crash日志捕获，捕获到后会在sdcard路径/sdcard/xiaoya/temp/crashlog目录下新建崩溃文件
仅捕获跟SDK相关的崩溃，宿主应用其他崩溃按android默认处理，不会在上述路径中存储
          </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Access.vue